<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :width-size="props.sizeSlideOver"
        :custom="['header', 'footer']"
        @close="closeOverSide">
        <template #header>
            <div class="hts-categorys-ignore-add-category">
                <div class="hts-categorys-ignore-add-category__container-header">
                    <h3 class="title">
                        <hi-plus-circle-icon class="icon" />
                        <span class="label">
                            {{ $t('labels.addcategory') }}
                        </span>
                    </h3>
                    <button
                        class="button_close"
                        @click="closeOverSide">
                        <hi-x-mark-icon
                            class="h-6 w-6"
                            aria-hidden="true" />
                    </button>
                </div>
            </div>
        </template>

        <template #body>
            <div class="hts-categorys-ignore-add-category">
                <div class="hts-categorys-ignore-add-category__container-body">
                    <!--        <hts-form> -->
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <hi-backward-icon class="icon overturned" />
                                <span class="label">
                                    {{ $t('labels.generalInformation') }}
                                </span>
                            </h3>
                        </template>
                        <div
                            class="grid gap-4"
                            :class="columnClass">
                            <hts-form-input
                                :label="$t('labels.categoryName')"
                                :required="true"
                                :color="props.color" />
                            <hts-form-input
                                :label="$t('labels.categoryPrice')"
                                :required="true"
                                :color="props.color" />
                            <hts-form-select
                                :label="$t('labels.categoryType')"
                                required
                                :items="listTypecategory"
                                key-id="id"
                                key-label="name"
                                :color="props.color" />
                            <hts-form-input
                                :label="$t('labels.yearOfManufacture')"
                                :color="props.color" />
                            <hts-form-input
                                :label="$t('labels.volumeGasoline')"
                                :color="props.color" />
                        </div>
                    </hts-card>

                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <hi-backward-icon class="icon overturned" />
                                <span class="label">
                                    {{ $t('labels.depreciation') }}
                                </span>
                            </h3>
                        </template>
                        <div
                            class="grid gap-4"
                            :class="columnClass">
                            <hts-form-input
                                :label="$t('labels.depreciationTime')"
                                :required="true"
                                :color="props.color" />
                            <hts-form-input
                                :label="$t('labels.depreciationCost')"
                                :required="true"
                                :color="props.color" />
                        </div>
                    </hts-card>

                    <hts-card class="card">
                        <template #title>
                            <h3 class="title">
                                <hi-backward-icon class="icon overturned" />
                                <span class="label">
                                    {{ $t('labels.accreditation') }}
                                </span>
                            </h3>
                        </template>
                        <div
                            class="grid gap-4"
                            :class="columnClass">
                            <hts-form-input
                                :label="$t('labels.inspectionCost')"
                                :required="true"
                                :color="props.color" />
                            <hts-form-input
                                :label="$t('labels.inspectionTime')"
                                :required="true"
                                :color="props.color" />
                        </div>
                    </hts-card>
                    <!--          </hts-form> -->
                </div>
            </div>
        </template>

        <template #footer>
            <div class="hts-categorys-ignore-add-category">
                <div class="hts-categorys-ignore-add-category__container-footer">
                    <div class="footer">
                        <div class="footer-left">
                            <hts-form-button
                                icon-name="hi-check-icon"
                                icon-position="right"
                                color="main"
                                type="submit">
                                {{ $t('labels.saveNewCar') }}
                            </hts-form-button>

                            <hts-form-button
                                color="white"
                                icon-name="hi-x-mark-icon"
                                icon-position="right"
                                disabled="true"
                                @click="closeOverSide">
                                {{ $t('labels.cancel') }}
                            </hts-form-button>
                        </div>

                        <div>
                            <hts-form-button
                                type="text"
                                color="error"
                                icon-name="hi-arrow-path-icon"
                                icon-position="right">
                                {{ $t('labels.undo') }}
                            </hts-form-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import { computed } from 'vue'

// const sizeItemInputDefault = ['mini', 'small', 'default', 'large', 'x-large', 'full']
// const sizeSlideOverDefault = ['mini', 'small', 'default', 'large', 'x-large', 'screen-sm', 'screen-md', 'screen-lg', 'screen-xl', 'screen-2xl']
// const colorDefault = ['active', 'info', 'success', 'error', 'warning', 'disable', 'default']

const listTypecategory = ref([
  {
    id: 1,
    name: 'Xe tải lớn'
  },
  {
    id: 2,
    name: 'Xe tải nhỏ'
  }
])

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'screen-lg'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 3
  }
})

const emits = defineEmits(['close'])

const closeOverSide = () => {
  emits('close')
}

// const cClass = computed(() => {
//   return {
//     [colorClass.value]: true,
//     [sizeSlideOverClass.value]: true,
//     [sizeItemInputClass.value]: true
//   }
// })

// const colorClass = computed(() => {
//   if ($lodash.includes(colorDefault, props.color)) {
//     return `color-${props.color}`
//   }
//   return 'color-default'
// })

// const sizeSlideOverClass = computed(() => {
//   if ($lodash.includes(sizeSlideOverDefault, props.sizeSlideOver)) {
//     return `size-slide-over-${props.sizeSlideOver}`
//   }
//   return 'size-slide-over-default'
// })

// const sizeItemInputClass = computed(() => {
//   if ($lodash.includes(sizeItemInputDefault, props.sizeItemInput)) {
//     return `size-input-${props.sizeItemInput}`
//   }
//   return 'size-input-default'
// })

const columnClass = computed(() => {
  switch (props.column) {
  case 1:
    return 'grid-cols-1'
  case 2:
    return 'grid-cols-2'
  case 3:
    return 'grid-cols-3'
  case 4:
    return 'grid-cols-4'
  case 5:
    return 'grid-cols-5'
  case 6:
    return 'grid-cols-6'
  case 7:
    return 'grid-cols-7'
  case 8:
    return 'grid-cols-8'
  case 9:
    return 'grid-cols-9'
  case 10:
    return 'grid-cols-10'
  case 11:
    return 'grid-cols-11'
  case 12:
    return 'grid-cols-12'
  }

  return 'grid-cols-1'
})
</script>
